import React from 'react';

const LoadingSpinner = ({ 
  size = 40, 
  color = '#00ca77', 
  text = 'Loading...', 
  showText = true,
  className = '' 
}) => {
  const spinnerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    border: `3px solid rgba(0, 202, 119, 0.2)`,
    borderTop: `3px solid ${color}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 16px',
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    textAlign: 'center',
  };

  const textStyle = {
    color: '#666',
    fontSize: '16px',
    fontWeight: '500',
    marginTop: '8px',
    fontFamily: 'inherit',
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .loading-pulse {
            opacity: 0.7;
            animation: pulse 1.5s ease-in-out infinite alternate;
          }
          
          @keyframes pulse {
            from { opacity: 0.7; }
            to { opacity: 1; }
          }
        `}
      </style>
      <div className={`${className}`} style={containerStyle}>
        <div style={spinnerStyle}></div>
        {showText && (
          <div className="loading-pulse" style={textStyle}>
            {text}
          </div>
        )}
      </div>
    </>
  );
};

// Componente específico para secciones de Firebase
export const FirebaseLoader = ({ 
  section = 'content', 
  details = [], 
  size = 50 
}) => {
  const getSectionText = () => {
    switch (section.toLowerCase()) {
      case 'blog':
        return 'Loading latest blog posts';
      case 'portfolio':
        return 'Loading portfolio projects';
      case 'contenthub':
        return 'Loading content hub';
      case 'infographics':
        return 'Loading infographics';
      default:
        return `Loading ${section}`;
    }
  };

  return (
    <div style={{ 
      textAlign: 'center', 
      padding: '60px 20px',
      minHeight: '200px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }}>
      <LoadingSpinner 
        size={size}
        text={getSectionText()}
        showText={true}
      />
      
      {details.length > 0 && (
        <div style={{
          marginTop: '20px',
          fontSize: '14px',
          color: '#999',
          fontStyle: 'italic'
        }}>
          {details.map((detail, index) => (
            <div key={index} style={{ marginBottom: '4px' }}>
              {detail}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
